const baseConfig = {
  siteTitle: "Whole Sol Blend Bar®",
  siteTitleAlt: "Whole Sol Blend Bar®",
  siteLogo: "",
  siteUrl: "https://wholesol.com",
  siteDescription:
    "100% Organic • Smoothies • Cold-Pressed Juice",
  schema: "FoodEstablishment",
  keywords: [],
  pageMetadata: {
    home: {
      title: "100% Organic • Smoothies • Cold-Pressed Juice",
      displayTitle: "Home",
      description: "5280 Magazine Names Whole Sol Blend Bar WINNER of TOP OF THE TOWN 2021, Best Brunch, Best Vegan/Vegetarian, Best Takeout | Gluten-Free | Dairy-Free",
      path: "/",
      toDisplay: false
    },
    locations: {
      title: "Locations",
      displayTitle: "Locations",
      description: "Visit us at 1735 Chestnut Place, behind the new Whole Foods' Union Station location, or in Boulder on the bricks at 14th & Pearl.",
      path: "/locations/",
      toDisplay: true
    },
    ourmenu: {
      title: "Menu",
      displayTitle: "Menu",
      description: "Whole means 100%. Our smoothie bols are designed to make you feel like a rockstar. Try the OG, Rise & Grind, our PB&J, or the Pina Colada Bol. Our ingredients are 100% organic & 100% real. The test is simple: if we wouldn’t eat it ourselves, we won’t serve it to you.",
      path: "https://www.wholesolblendbar.com/s/order",
      toDisplay: true,
      groupName: "Menus"
    },
    allergyMenu: {
      title: "Nutritional Info",
      displayTitle: "Nutritional Info",
      description: "Whole means 100%. Our smoothie bols are designed to make you feel like a rockstar. Try the OG, Rise & Grind, our PB&J, or the Pina Colada Bol. Our ingredients are 100% organic & 100% real. The test is simple: if we wouldn’t eat it ourselves, we won’t serve it to you.",
      path: "https://wholesol.com/static/Whole%20Sol%20Nutrition%20Facts%20(1).1e0a6a77.pdf",
      toDisplay: true,
      groupName: "Menus"
    },
    // juicePass: {
    //   title: "Juice Pass",
    //   displayTitle: "Juice Pass",
    //   description: "Whole means 100%. Our smoothie bols are designed to make you feel like a rockstar. Try the OG, Rise & Grind, our PB&J, or the Pina Colada Bol. Our ingredients are 100% organic & 100% real. The test is simple: if we wouldn’t eat it ourselves, we won’t serve it to you.",
    //   path: "/jp/",
    //   toDisplay: true,
    //   groupName: "Deals"
    // },
    events: {
      title: "Events",
      displayTitle: "Events",
      description: "",
      path: "/events/",
      toDisplay: true
    },
    wholesale: {
      title: "Wholesale",
      displayTitle: "Wholesale",
      description: "",
      path: "/wholesale/",
      toDisplay: true
    },
    about: {
      title: "About Us",
      displayTitle: "About Us",
      description: "Voted Best New Restaurant, Best Brunch, Best Vegan/Vegetarian by 5280 Magazine Readers' Choice 2019. USDA Organic Certified Juice. 100% Gluten-Free, Dairy-Free.",
      path: "/about/",
      toDisplay: true,
      // groupName: "About"
    },
    safety: {
      isInternal: false,
      title: "Covid Safety",
      displayTitle: "Covid Safety",
      description: "",
      path: "/safety-procedures/",
      toDisplay: false,
      groupName: "About"
    },
    giftCards: {
      isInternal: false,
      title: "Gift Cards",
      displayTitle: "Gift Cards",
      description: "",
      path: "https://squareup.com/gift/42FR6HQFVBNMM/order?external_source=postoffice-email&external_token=V24TQ795fU23r4Ap",
      toDisplay: true
    },
    jobs: {
      isInternal: false,
      title: "Jobs",
      displayTitle: "Jobs",
      description: "",
      path: "https://whole-sol-blend-bar.r365hire.com/jobs",
      toDisplay: true
    },
  }
};

export const linksOrder = [
  { slug: "locations" },
  { groupName: "Menus" },
  // { slug: "ourmenu" },
  // { groupName: "Deals" },
  { slug: "events" },
  { slug: "wholesale" },
  { slug: "about" },
  { slug: "giftCards" },
  { slug: "jobs" }
];

export default baseConfig;



// WEBPACK FOOTER //
// ./config/baseConfig.js